export default function Grants() {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="bg-white rounded-lg shadow-md p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8 mb-10">
            <div className="flex gap-6 items-center flex-shrink-0">
              <img
                src="https://static.readdy.ai/image/6ae913d34dc5289e66b9f22e1ec27e15/c2fa2609ff91acb6a33f1eb2e03e8ac9.jpeg"
                alt="SPRI Grupo Taldea - Gobierno Vasco"
                className="h-24 w-auto"
              />
              <img
                src="https://static.readdy.ai/image/6ae913d34dc5289e66b9f22e1ec27e15/4b67fad984406d351154bd5f51f9145a.jpeg"
                alt="Eurorregión - Euroeskualdea"
                className="h-24 w-auto"
              />
            </div>
            <div className="flex-1">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                Proyectos Subvencionados
              </h2>
              <p className="text-gray-600 text-sm md:text-base">
                Talleres Lujambio participa en proyectos de innovación apoyados por el Gobierno Vasco a través de SPRI y la Eurorregión
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="border-l-4 border-teal-600 bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start mb-3">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mr-3">
                  <i className="ri-lightbulb-line text-xl text-white"></i>
                </div>
                <h3 className="font-bold text-gray-900 text-lg">
                  Proyecto IMPELLER
                </h3>
              </div>
              <div className="ml-13 space-y-2">
                <p className="text-sm text-gray-700">
                  <strong>Programa:</strong> Ayudas Basque Digital Innovation Hub (BDIH) - Konexio 2025
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Expediente:</strong> BDI-2025-00064
                </p>
              </div>
            </div>

            <div className="border-l-4 border-teal-600 bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start mb-3">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mr-3">
                  <i className="ri-rocket-line text-xl text-white"></i>
                </div>
                <h3 className="font-bold text-gray-900 text-lg">
                  Proyecto PROFECIA
                </h3>
              </div>
              <div className="ml-13 space-y-2">
                <p className="text-sm text-gray-700">
                  <strong>Programa:</strong> PROGRAMA HAZITEK Convocatoria 2025
                </p>
                <p className="text-sm text-gray-700">
                  <strong>Expediente:</strong> ZE-2025/00009
                </p>
              </div>
            </div>

            <div className="border-l-4 border-teal-600 bg-gray-50 p-6 rounded-lg">
              <div className="flex items-start mb-3">
                <div className="w-10 h-10 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 mr-3">
                  <i className="ri-tools-line text-xl text-white"></i>
                </div>
                <h3 className="font-bold text-gray-900 text-lg">
                  Proyecto MMAM
                </h3>
              </div>
              <div className="ml-13 space-y-2">
                <p className="text-sm text-gray-700">
                  <strong>Programa:</strong> INNOVACIÓN EURORREGIONAL – Fabricación Avanzada
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
